import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "bed" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    d: "M7.5 12C8.87844 12 10 10.8784 10 9.5C10 8.12156 8.87844 7 7.5 7C6.12156 7 5 8.12156 5 9.5C5 10.8784 6.12156 12 7.5 12ZM18.5 8H11.5C11.2237 8 11 8.22375 11 8.5V13H4V6.5C4 6.22375 3.77625 6 3.5 6H2.5C2.22375 6 2 6.22375 2 6.5V17.5C2 17.7763 2.22375 18 2.5 18H3.5C3.77625 18 4 17.7763 4 17.5V16H20V17.5C20 17.7763 20.2237 18 20.5 18H21.5C21.7763 18 22 17.7763 22 17.5V11.5C22 9.56687 20.4331 8 18.5 8Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }